var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "list_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11351",
    "data-name": "Group 11351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18383",
    "data-name": "Path 18383",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18384",
    "data-name": "Path 18384",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0.87
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    d: "M136-836.445v10.667a1.712,1.712,0,0,1-.522,1.256,1.712,1.712,0,0,1-1.256.522H121.778a1.712,1.712,0,0,1-1.256-.522,1.712,1.712,0,0,1-.522-1.256v-12.444a1.712,1.712,0,0,1,.522-1.256,1.712,1.712,0,0,1,1.256-.522h10.667Zm-1.778.756-2.533-2.533h-9.911v12.444h12.444ZM128-826.667a2.571,2.571,0,0,0,1.889-.778,2.572,2.572,0,0,0,.778-1.889,2.572,2.572,0,0,0-.778-1.889A2.571,2.571,0,0,0,128-832a2.572,2.572,0,0,0-1.889.778,2.572,2.572,0,0,0-.778,1.889,2.572,2.572,0,0,0,.778,1.889A2.572,2.572,0,0,0,128-826.667Zm-5.333-7.111h8v-3.555h-8Zm-.889-1.911v0Z",
    transform: "translate(-116 844)",
    fill: "#f1f1f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcn);
export default __webpack_public_path__ + "static/media/save-icn.f87f2a66da73abe8a7ae4e34b220e5e6.svg";
export { ForwardRef as ReactComponent };